
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-positive-care",
      function () {
        return require("private-next-pages/covid-positive-care.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/covid-positive-care"])
      });
    }
  